import(/* webpackMode: "eager" */ "/opt/render/project/src/apps/criteria-playground/src/app/[[...snapshot]]/page-client-content.tsx")